{
  "en": {
    "editor_ziggu": {
      "actions": {
        "apply": "Apply",
        "cancel": "Cancel",
        "link": "Link",
        "showLess": "Show less",
        "showMore": "Show more"
      },
      "labels": {
        "blue": "Blue",
        "green": "Green",
        "link_text": "Link text",
        "orange": "Orange",
        "pink": "Pink",
        "purple": "Purple",
        "red": "Red",
        "remove_highlight": "Remove highlight",
        "yellow": "Yellow"
      },
      "placeholders": {
        "content": "Start typing..",
        "link": "Type/paste a link"
      }
    }
  }
}
